import React, { useEffect, useRef, useState, useContext } from 'react'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import Card from '../../../Components/Card/Card'
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid';
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { setTitlePage } from '../../../Services/Config/ConfigService';

import { getEstadosSecurity } from '../../../../API/Global/Status/StatusRequests';
import EstadosCRUD from './EstadosCRUD';

const EstadosScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const d = await getEstadosSecurity();
    setData(d);
    setLoading(false);
  };

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdStatus",
      hidden: userAuth.IdRol === 1,
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: 'Estado',
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "StatusCategory",
      className: "XXlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Descripción",
      headerEn: "Description",
      field: "StatusDescription",
      className: "large",
      flex: 1,
      minWidth: 200,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },

    {
      field: "IdAccess",
      className: "small",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: true,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {position: "left"},
        },
      ],
    },
  ];

  const table = {
      Columns: columns,
      Data: data,
      loading: loading
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Estados", config.language));
    getInfo();
  }, [])


  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "Estados", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="pt-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />


      {showDialog && (
        <EstadosCRUD
          dialog = {showDialog}
          setDialog = {setShowDialog}
          selected = {selected}
          setSelected  = {setSelected}
          modo = {selected ? "Editar": "Crear"}
          getInfo = {getInfo}
        />
      )}
    </div>
  );
}

export default EstadosScreen